import styled from 'styled-components';

export const KitStyle = styled.section`
  width: 100%;
  background: #f2fff7;
  padding-bottom: 100px;

  > div {
    flex-direction: column;

    h2 {
      color: #009f67;
      font-size: 58px;
      text-align: center;
      font-family: 'FeltThatW01-Regular';
    }
  }

  .BrainhubCarousel__arrows {
    background-color: transparent!important;

    span {
      display: none!important;
    }

    &:hover:enabled {
      background-color: transparent!important;
    }
  }

  .BrainhubCarousel__arrowLeft {
    background: url(https://emprendeoboticario.com.co/wp-content/themes/twentytwenty-child/images/left-arrow.svg) top center no-repeat transparent;
  }

  .BrainhubCarousel__arrowRight {
    background: url(https://emprendeoboticario.com.co/wp-content/themes/twentytwenty-child/images/right-arrow.svg) top center no-repeat transparent;
  }

  .BrainhubCarousel__dots {
    margin-top: 20px;
    button {
      background: transparent;
    }
  }

  @media(min-width: 801px) {
    .BrainhubCarousel__container {
      display: none;
    }
  }
`;

export const KitGroup = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 20px;

  @media(max-width: 800px) {
    display: none;
  }
`;

export const KitItem = styled.div`
  display: flex;
  width: 260px;
  flex-direction: column;
  justify-content: center;

  table {
    tr {
      td {
        color: #169e69;
        font-size: 17px;
        letter-spacing: -0.38px;
        text-align: left;
        font-weight: 900;
        font-style: italic;
        font-family: 'DomaineSansText-BlackItalic';
        padding: 0 0.5em 0 0.5em;
        border: none;

        &:first-child {
          text-align: right;
        }
      }
    }

    .highlight {
      background: #169e69;

      td {
        color: #fff;
      }
    }
  }
`;

export const KitBanner = styled.div`
  margin: 25px 0;

  @media(max-width: 800px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
export const KitBannerContent = styled.div`
  display: flex;
  height: 116px;
  justify-content: center;

  img {
    width: 320px;
    margin-bottom: 10px;
    margin-right: 23px;
  }

  @media(max-width: 800px) {
    height: auto;
    flex-direction: column;
  }
`;

export const KitBannerContentText = styled.div`
  border-bottom: solid 1px #00716b;
  padding: 10px 0;
`;

export const KitBannerContentTextItem = styled.span`
  display: block;
  color: #0a3941;
  font-size: ${props => props.primary ? '60px' : '43px'};
  font-family: ${props => props.primary ? 'DomaineSansText-Black' : 'DomaineSansText-Medium'};
  line-height: 0.9;
  letter-spacing: -3.01px;
`;

export const KitTitle = styled.h3`
  color: #007e78;
  font-size: 40px;
  text-align: center;
  margin-bottom: 10px;
  font-family: 'FeltThatW01-Regular';
`;

export const KitText = styled.p`
  color: #273a46;
  font-size: 13px;
  line-height: 1.23;
  text-align: center;
  margin: 10px 0;
`;
